import { useState } from "react";
import { ToolBtn } from "../ToolBtn";
import secondaryComponents from "../..";
import primaryComponents from "../../../primaryComponents";
import { useCheckoutHelper } from "../../../../hooks/useCheckoutHelper";
import { useGetPharmacyOption } from "../../../../hooks/api/queries/useOrder";
import { RoutedModal } from "../../../common";
import { CreatePharmacyIndication } from "./CreatePharmacyIndication";

export const CheckoutPharmacyIndication = ({ btnStyle }) => {
  const [isOrderType, setIsOrderType] = useState(false);
  const [isCreateIndication, setIsCreateIndication] = useState(false);
  const { indication, setIndication } = useCheckoutHelper();
  const { data, isLoading } = useGetPharmacyOption({
    isEnabled: isOrderType,
  });
  const indicationList = data?.patient_indications || [];
  const indicationLabel = indication?.patient_indications
    ?.map((selectedIndication) => {
      const result = indicationList?.find(
        (item) => `${item?.value}` === `${selectedIndication}`,
      );

      return result?.label;
    })
    ?.join(", ");

  return (
    <>
      <div className="w-100">
        <ToolBtn
          text="Indication"
          borderColor={"transparent"}
          onClick={() => setIsOrderType(true)}
          style={btnStyle}
          contentText={indicationLabel || null}
        />
      </div>

      <secondaryComponents.Modal
        isActive={isOrderType}
        width={500}
        closeModal={() => setIsOrderType(false)}
      >
        <div className="d-flex flex-column p-2" style={{ gap: "15px" }}>
          <div>
            <h4 className="mb-0">Select Indication</h4>
            <hr />
          </div>

          <secondaryComponents.LoaderHelper
            isLoading={isLoading}
            classNames={"mt-4"}
          >
            <div className="d-flex flex-column w-100" style={{ gap: "10px" }}>
              <primaryComponents.MultipleSelectField
                label={
                  <>
                    Indication{" "}
                    <span
                      className="purple--text cursor-pointer"
                      onClick={() => setIsCreateIndication(true)}
                    >
                      (Create)
                    </span>
                  </>
                }
                options={indicationList}
                nameKey={"label"}
                idKey={"value"}
                isRequired
                giveControl={false}
                value={indication?.patient_indications?.map(
                  (selectedIndication) => {
                    const result = indicationList?.find(
                      (item) => `${item?.value}` === `${selectedIndication}`,
                    );

                    return {
                      label: result?.label,
                      value: result?.value,
                    };
                  },
                )}
                placeholder="Select indications..."
                onChange={(indications) => {
                  setIndication({
                    ...indication,
                    patient_indications: indications?.map(
                      (item) => item?.value,
                    ),
                  });
                }}
              />

              {/* <TextAreaV2 N/> */}
            </div>
          </secondaryComponents.LoaderHelper>

          <primaryComponents.Button
            classNames={"btn btn--primary cover mt-3"}
            onClick={() => setIsOrderType(false)}
          >
            Continue
          </primaryComponents.Button>
        </div>
      </secondaryComponents.Modal>

      <RoutedModal
        isActive={isCreateIndication}
        width={400}
        style={{ height: "auto" }}
        closeModal={() => setIsCreateIndication(false)}
      >
        <CreatePharmacyIndication
          closeModal={() => setIsCreateIndication(false)}
        />
      </RoutedModal>
    </>
  );
};
